import React, { useState, useEffect, useRef } from "react";
import classes from "./Buttons.module.css";
import { CgSun } from "react-icons/cg";
import { HiMoon } from "react-icons/hi";

const Buttons = (props) => {
  const [limitMessage, setLimitMessage] = useState("");
  const limitMessageTimer = useRef(null);

  const icon =
    Number(props.darkTheme) === 0 ? <HiMoon size="2.25em" /> : <CgSun size="2.25em" />;

  const atMaxFont = props.fontSize >= props.maxFontSize;
  const atMinFont = props.fontSize <= props.minFontSize;

  useEffect(() => {
    return () => clearTimeout(limitMessageTimer.current);
  }, []);

  function onThemeChanged() {
    const themeBtn = document.getElementById("theme-button");
    const label = themeBtn.ariaLabel

    if(label === "Toggle Theme to Dark Mode"){
      themeBtn.ariaLabel = "Toggle Theme to Light Mode"
    }
    else {
      themeBtn.ariaLabel = "Toggle Theme to Dark Mode"
    }

    props.onToggleClick()
  }

  //Clear the message first so screen readers announce it again on repeated clicks.
  function announceLimit(message) {
    clearTimeout(limitMessageTimer.current);
    setLimitMessage("");
    limitMessageTimer.current = setTimeout(() => setLimitMessage(message), 100);
  }

  function onFontIncrease() {
    if(atMaxFont){
      announceLimit("Maximum font size reached");
      return;
    }
    setLimitMessage("");
    props.onFontIncreaseClick();
  }

  function onFontDecrease() {
    if(atMinFont){
      announceLimit("Minimum font size reached");
      return;
    }
    setLimitMessage("");
    props.onFontDecreaseClick();
  }

  function onFontReset() {
    setLimitMessage("");
    props.onFontClick();
  }

  return (
    <div className={classes["container"]} style={{ fontSize: props.headerFontSize }}>
      <div className={classes["column"]}>
        <button
          id="theme-button"
          className={classes["toggle"]}
          onClick={ onThemeChanged }
          aria-label={props.darkTheme !== 0? 'Toggle Theme to Dark Mode': 'Toggle Theme to Light Mode'}
        >
          {icon}
        </button>
      </div>
      <div className={classes["column"]}>
        <button
          className={classes["font-toggle"]}
          onClick={onFontIncrease}
          aria-label="increase font"
          aria-disabled={atMaxFont}
        >
          {"A+"}
        </button>
      </div>
      <div className={classes["column"]}>
        <button
          className={classes["font-toggle"]}
          onClick={onFontReset}
          aria-label="default font"
        >
          {"A"}
        </button>
      </div>
      <div className={classes["column"]}>
        <button
          className={classes["font-toggle"]}
          onClick={onFontDecrease}
          aria-label="decrease font"
          aria-disabled={atMinFont}
        >
          {"A-"}
        </button>
      </div>
      <div className={classes["visually-hidden"]} aria-live="polite">
        {limitMessage}
      </div>
    </div>
  );
};

export default Buttons;
